import React, { FC } from 'react';
import { Form } from '@ant-design/compatible';
import { AdvancedFilters } from '../../advanced_filters/AdvancedFilters';
import {
	changeFilterValueToArrayOfIds,
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../../utils/DataAccessUtils';
import BuyerRegionsLocationsTreeSelect from '../../regions_tree_select/RegionsLocationsTreeSelect';
import { ROLE_TYPES } from '../../../utils/DataConstants';
import SupplierRegionsLocationsTreeSelect from '../../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import { WORK_ORDER_SORTERS } from '../config/sorters/sorters';

interface FiltersProps {
	filters: any;
	applyFilters: any;
	clearFilters: any;
	targetCollectionName: String;
	filterConfig: any;
	userType: any;
	sorters: any;
	applySorting: any;
	preAppliedFilters: any;
	currentUser: any;
}

const Filters: FC<FiltersProps> = ({
	preAppliedFilters,
	filters,
	applyFilters,
	applySorting,
	clearFilters,
	targetCollectionName,
	filterConfig,
	userType,
	sorters,
	currentUser,
}): React.ReactElement => {
	const LocationComponent =
		ROLE_TYPES.SUPPLIER === userType
			? SupplierRegionsLocationsTreeSelect
			: BuyerRegionsLocationsTreeSelect;
	return (
		<AdvancedFilters
			updateFilters={applyFilters}
			filterConfig={filterConfig}
			filtersTargetCollectionName={targetCollectionName}
			clearAndUpdateFilters={clearFilters}
			initialFilters={filters}
			filtersStateSlice={filters}
			applySorting={applySorting}
			sorters={sorters}
			sorterItems={WORK_ORDER_SORTERS}
			preAppliedFilters={preAppliedFilters}
		>
			{isSupplierPayingCustomer(currentUser) ? null : (
				<Form.Item label="Location">
					<LocationComponent
						mode="multiple"
						allowClear={true}
						filtersSlice={filters}
						filtersValueAccessor={(filtersStateSlice) => {
							const locationIds = nullSafeGet(`locationIds`, filtersStateSlice);
							const finalIds = nullSafeGetOrElse(`regionIds`, filtersStateSlice, locationIds);
							return changeFilterValueToArrayOfIds(finalIds);
						}}
						onChange={(ids) => {
							applyFilters({
								locationIds: ids.join(',') || undefined,
								regionIds: undefined,
							});
						}}
						targetCollectionName={'workOrdersAdvancedFilters'}
					/>
				</Form.Item>
			)}
		</AdvancedFilters>
	);
};

export default Filters;
